/* ==========================================================================
   PDP Stoffkombination: Info-Popup zu Fein, Mittelgrob und Damast
   Leinenweberei Hoffmann, 09.08.2026

   HOFFMANN 09.08.2026: Auf den Wende-Produktseiten waehlt der Kunde zuerst die
   Option "Stoffkombination" (Werte wie "Mittelgrob & Fein"). Viele Kunden wissen
   an dieser Stelle nicht, was Fein, Mittelgrob und Damast bedeuten. Sie bekommen
   deshalb neben der Ueberschrift dasselbe kleine i-Icon wie im Wende-Konfigurator
   und dahinter ein Popup mit denselben Klassen (.pdp-wende-popup), damit das
   bereits vorhandene CSS aus assets/pdp-wende.css unveraendert greift.

   Warum eine eigene Datei und nicht direkt im Markup:
   Die Ueberschrift "Stoffkombination" wird von sections/pdp-main.liquid gerendert.
   Diese Datei ist rund 45 kB gross und laesst sich ueber die hier verfuegbare
   Schnittstelle (Theme-Files-API) nicht zuverlaessig aendern - grosse Uploads
   werden dabei beschaedigt. Das Icon und das Popup werden deshalb zur Laufzeit
   eingehaengt. Geladen wird die Datei aus snippets/pdp-fonts.liquid, genau wie
   assets/pdp-height.js. Wer die Logik spaeter fest in die Section einbaut,
   loescht diese Datei und die Zeile im Snippet.

   Das Skript wird nur aktiv, wenn auf der Seite ein Wende-Konfigurator steht
   ([data-pdp-wende] bzw. [data-pdp-wende-knopf]). Nur dort ist pdp-wende.css
   geladen, und nur dort gibt es die Option "Stoffkombination".

   Sichtbarkeit wie in assets/pdp-wende.js (Funktion show): das hidden-Attribut
   allein reicht im Focal-Theme nicht, weil Klassen mit display-Regel es
   schlagen. Deshalb wird display zusaetzlich gesetzt bzw. entfernt.
   ========================================================================== */
(function () {
  'use strict';

  var LABEL_MATCH = 'stoffkombination';

  var POPUP_HTML =
    '<div class="pdp-wende-popup" data-pdp-stoff-popup hidden>' +
      '<div class="pdp-wende-popup__overlay" data-pdp-stoff-popup-close></div>' +
      '<div class="pdp-wende-popup__card" role="dialog" aria-modal="true" aria-label="Stoffqualitäten">' +
        '<button type="button" class="pdp-wende-popup__close" data-pdp-stoff-popup-close aria-label="Schließen">×</button>' +
        '<h3 class="pdp-wende-popup__title">Welche Stoffe kann ich kombinieren?</h3>' +
        '<div class="pdp-wende-popup__text">' +
          '<p>Alle drei sind 100&nbsp;% Leinen aus unserer eigenen Weberei. Sie unterscheiden sich in Gewicht und Oberfläche.</p>' +
          '<p><strong>Fein, ca.&nbsp;185&nbsp;g/m²</strong>: glatt und leicht, der zarteste Stoff, angenehm kühl im Sommer.</p>' +
          '<p><strong>Mittelgrob, ca.&nbsp;215&nbsp;g/m²</strong>: kräftiger und griffiger, mit sichtbarer Struktur.</p>' +
          '<p><strong>Damast, ca.&nbsp;220&nbsp;g/m²</strong>: eingewebtes Muster mit sanftem Glanz, je nach Licht tritt es hervor.</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  /* .pdp-size-head ist ein Flex-Container mit justify-content: space-between
     (siehe assets/pdp.css). Ein drittes Kind wuerde deshalb nach rechts rutschen.
     Label und Icon kommen darum in einen gemeinsamen Inline-Wrapper.
     HOFFMANN 01.09.2026: Ausrichtung von baseline auf center umgestellt. Ein
     runder Kreis laesst sich an der Schriftlinie nicht sauber ausrichten, das
     Icon sass sichtbar zu tief. Die Korrektur top: -1px entfaellt damit. */
  function injectStyles() {
    if (document.getElementById('pdp-stoff-info-styles')) return;
    var el = document.createElement('style');
    el.id = 'pdp-stoff-info-styles';
    el.textContent = [
      '.pdp-stoff-info-wrap{display:inline-flex;align-items:center;gap:6px;min-width:0;}',
      '.pdp-stoff-info-wrap .pdp-wende__info{line-height:1;}'
    ].join(' ');
    document.head.appendChild(el);
  }

  /* Sichtbarkeit exakt wie show() in assets/pdp-wende.js. */
  function show(el, on) {
    if (!el) return;
    el.removeAttribute('hidden');
    if (on) el.style.removeProperty('display');
    else el.style.setProperty('display', 'none', 'important');
  }

  function findGroup(root) {
    var groups = root.querySelectorAll('.pdp-size-group');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.pdp-option-label');
      if (!label) continue;
      var txt = (label.textContent || '').toLowerCase();
      if (txt.indexOf(LABEL_MATCH) !== -1) return groups[i];
    }
    return null;
  }

  function init() {
    if (window.__pdpStoffInfo) return;

    var root = document.querySelector('[data-pdp-main]');
    if (!root) return;

    /* Nur auf Wende-Produktseiten. Dort steht der Konfigurator-Container und
       damit auch das CSS, von dem Icon und Popup leben. */
    var hasWende = document.querySelector('[data-pdp-wende]') ||
                   document.querySelector('[data-pdp-wende-knopf]');
    if (!hasWende) return;

    var group = findGroup(root);
    if (!group) return;

    var head = group.querySelector('.pdp-size-head');
    if (!head) return;

    var label = head.querySelector('.pdp-option-label');
    if (!label) return;

    if (head.querySelector('[data-pdp-stoff-info]')) return;

    window.__pdpStoffInfo = true;
    injectStyles();

    var trigger = document.createElement('span');
    trigger.className = 'pdp-wende__info';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('data-pdp-stoff-info', '');
    trigger.setAttribute('aria-label', 'Was bedeuten Fein, Mittelgrob und Damast?');
    trigger.textContent = 'i';

    var wrap = document.createElement('span');
    wrap.className = 'pdp-stoff-info-wrap';
    if (label.parentNode) label.parentNode.insertBefore(wrap, label);
    wrap.appendChild(label);
    wrap.appendChild(trigger);

    var holder = document.createElement('div');
    holder.innerHTML = POPUP_HTML;
    var popup = holder.firstChild;
    if (!popup) return;
    document.body.appendChild(popup);

    /* Der Klick darf die darunterliegende Variantenauswahl nicht ausloesen. */
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      show(popup, true);
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        show(popup, true);
      }
    });

    var closers = popup.querySelectorAll('[data-pdp-stoff-popup-close]');
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        show(popup, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      show(popup, false);
    });

    show(popup, false);
  }

  function boot() {
    try { init(); } catch (e) { /* nie die Buy-Box blockieren */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
